// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"30c3e8fd","488":"2e55880f","732":"307d2632","952":"b9ab7e5a","977":"beb5ea83"}[chunkId] + ".chunk.js";
};